import $$ from 'jquery'
import FrameBoxModal from '@/common/FrameBox'
import exoEventBus from '@modules/exoEventBus'

let modal

const exoFrame = {
    open(params) {
        let defaults = {
            height: '90%',
            width: '90%',
            inner: {
                css: {
                    'max-width': '1350px'
                }
            }
        };
        defaults = $$.extend(defaults, params);
        modal = new FrameBoxModal(defaults)
        return modal.open()
    },

    preload(params) {
        if (modal) return
        let defaults = {
            height: '90%',
            width: '90%',
            inner: {
                css: {
                    'max-width': '1350px'
                }
            }
        };
        defaults = $$.extend(defaults, params);
        modal = new FrameBoxModal(defaults)
        return modal.preload()
    },

    reopen() {
        if (modal) {
            return modal.reopen()
        }
        return Promise.resolve()
    },

    /** Whether there is a frame, and it is still in the document. */
    has() {
        return !!(modal && modal.$modal && modal.$modal[0] && modal.$modal[0].isConnected)
    },

    close() {
        if (modal) {
            modal.close()
            // Detached is gone for our purposes: the next open()/preload()
            // makes a new one instead of reopening an element outside the DOM.
            modal = undefined
        }
    },

    /** Throw the frame away - one that never came up, or that was detached. */
    discard() {
        if (modal) {
            modal.destroy()
            modal = undefined
        }
    },

    softClose() {
        if (modal) {
            modal.softClose()
        }
    },
}

exoEventBus.$on('exolog-exo-modal-cancel', exoFrame.close);

export default exoFrame
